import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyPostbacks = lazy(() => import('./Postbacks'));

export const Postbacks: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyPostbacks {...props} />
	</Suspense>
);
